import type { GithubIssueLink } from '@/lib/github-issues/types';

/** "#12" for an issue in the PR's repository, "owner/repo#12" otherwise. */
export function getGithubIssueLabel(
  issue: Pick<GithubIssueLink, 'number' | 'repository'>,
  pullRequestRepository: { owner: string; repo: string },
): string {
  const isSameRepository =
    issue.repository.nameWithOwner.toLowerCase() ===
    `${pullRequestRepository.owner}/${pullRequestRepository.repo}`.toLowerCase();
  return isSameRepository
    ? `#${issue.number}`
    : `${issue.repository.nameWithOwner}#${issue.number}`;
}
